import apiCall from "../apiService";
import { AUTH_ROUTES } from "../../utils/constants/apiRoute";
/**
 * Updates an existing cashier's data using a PUT request.
 * Requires admin privileges (based on backend authorization).
 *
 * @function
 * @param {string} cashierId - The ID of the cashier to update.
 * @param {Object} updatedData - The updated cashier information.
 * @param {string} updatedData.name - Updated name of the cashier.
 * @param {string} updatedData.username - Updated username of the cashier.
 * @param {string} updatedData.password - Updated password of the cashier.
 * @param {string} updatedData.role - Role of the cashier (e.g., 'cashier').
 * @param {boolean} updatedData.active - Status of the cashier (active/inactive).
 * @returns {Promise<Object>} The updated cashier data from the server.
 * @throws Will throw an error if the request fails.
 * 
 * Mishra
 */
const updateCashiers = async (cashierId, updatedData) => {
  return await apiCall(`${AUTH_ROUTES.USERS_API_ENDPOINT}/${cashierId}`, {
    method: "PUT",
    body: {
      name: updatedData.name,
      username: updatedData.username,
      email: updatedData.email,
      password: updatedData.password,
      role: updatedData.role,
      active: updatedData.active,
    },
  });
};

export default updateCashiers;
